import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const CHANGE_IMY_PARENT_ACCOUNT_REQUEST = 'CHANGE_IMY_PARENT_ACCOUNT_REQUEST';
export const CHANGE_IMY_PARENT_ACCOUNT_SUCCESS = 'CHANGE_IMY_PARENT_ACCOUNT_SUCCESS';
export const CHANGE_IMY_PARENT_ACCOUNT_FAILURE = 'CHANGE_IMY_PARENT_ACCOUNT_FAILURE';

function requestChangeImyParentAccount(name, changeDetails) {
  return {
    type: CHANGE_IMY_PARENT_ACCOUNT_REQUEST,
    name,
    changeDetails
  };
}

function receiveChangeImyParentAccount(accountId, statementContainer) {
  return {
    type: CHANGE_IMY_PARENT_ACCOUNT_SUCCESS,
    accountId,
    statementContainer
  };
}

function rejectChangeImyParentAccount(accountId) {
  return {
    type: CHANGE_IMY_PARENT_ACCOUNT_FAILURE,
    accountId
  };
}

export function changeImyTierParent(accountId, changeDetails) {
  return (dispatch) => {
    dispatch(requestChangeImyParentAccount(accountId, changeDetails));
    const promise = () => ApiService
      .updateWithholdingStatementImyParent(accountId, changeDetails)
      .then((response) => {
        dispatch(receiveChangeImyParentAccount(accountId, response.data));
        if (response.data) {
          toastr.success('Save Successful', 'IMY Tier Parent change successful');
        } else {
          toastr.error('Save Failed', 'There was an unexpected response when changing the IMY Tier parent');
        }
      })
      .catch(error => dispatch(handleException(error, () => dispatch(rejectChangeImyParentAccount(accountId)), true)));

    return promise();
  };
}
